import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

interface Props {
    note: string;
}

function CouponNote({ note }:Props) {
    const { t } = useTranslation('coupon');
    return (
        <Container fullWidth spacing={8}>
            <Text size='xl' fontWeight='bold' color={colors.gray7}>
                {t('detail.note')}
            </Text>
            <Notes fullWidth spacing={4}>
                <NoteContents as='div'
                    color={colors.gray7}
                    dangerouslySetInnerHTML={{ __html: note }} />
            </Notes>
        </Container>
    );
}

const Container = styled(Column)`
    margin-bottom: 64px;
    margin-top: 24px;
    padding: 0 20px;
`;

const Notes = styled(Column)`
    background-color: var(--color-gray3);
    border-radius: 8px;
    counter-reset: note;
    padding: 12px;
`;

const NoteContents = styled(Text)`
    counter-increment: note;
    position: relative;
    max-width: 100%;
    white-space: pre-wrap;
    word-break: break-word;
    
    ul {
        list-style-type: disc;
        list-style-position: outside;
        display: block;
        padding-left: 16px;
    }

    ol {
        list-style-type: decimal;
        list-style-position: outside;
        padding-left: 16px;
    }

    li {
        display: list-item;
    }

    h1, h2, h3 {
        font-weight: 400;
    }

    h1 {
        font-size: 24px;
    }

    h2 {
        font-size: 20px;
    }

    h3 {
        font-size: 16px;
    }

    p {
        font-size: 14px;
    }
`;

export default CouponNote;
